var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 2.5C1.33579 2.5 1 2.83579 1 3.25C1 3.66421 1.33579 4 1.75 4H12.25C12.6642 4 13 3.66421 13 3.25C13 2.83579 12.6642 2.5 12.25 2.5H1.75ZM5.75 7.5C5.33579 7.5 5 7.83579 5 8.25C5 8.66421 5.33579 9 5.75 9H14.25C14.6642 9 15 8.66421 15 8.25C15 7.83579 14.6642 7.5 14.25 7.5H5.75ZM5.75 12.5C5.33579 12.5 5 12.8358 5 13.25C5 13.6642 5.33579 14 5.75 14H14.25C14.6642 14 15 13.6642 15 13.25C15 12.8358 14.6642 12.5 14.25 12.5H5.75ZM2.5 7.75C2.5 7.33579 2.16421 7 1.75 7C1.33579 7 1 7.33579 1 7.75V13.75C1 14.1642 1.33579 14.5 1.75 14.5C2.16421 14.5 2.5 14.1642 2.5 13.75V7.75Z",
    fill: "#586069"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.367843e3da6c094a7b1b4a6cf20600b4.svg";
export { ForwardRef as ReactComponent };